export interface StripeOpenModalActionType {
  type: '@stripe/OPEN_MODAL';
}

export const openModal = (): StripeOpenModalActionType => ({
  type: '@stripe/OPEN_MODAL',
});
